function move(moveElement: Element, element: Element, moveBefore = true) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    element.parentNode.insertBefore(moveElement, moveBefore ? element : element.nextSibling);
}

export function portal(
    node: Element,
    { to = document.body.lastElementChild, enable = true, moveBefore = false } = {}
): object {
    if (enable && to) {
        if (to?.parentNode) {
            move(node, to, moveBefore);
        } else {
            to.appendChild(node);
        }
    }

    return {
        update({ to2 = document.body.lastElementChild, enable2 = true, moveBefore2 = false } = {}) {
            if (enable2 && to2) {
                if (to2?.parentNode) {
                    move(node, to2, moveBefore2);
                } else {
                    to2.appendChild(node);
                }
            }
        },
        // eslint-disable-next-line no-empty-function,@typescript-eslint/no-empty-function
        destroy() {
            node.parentNode?.removeChild(node);
        },
    };
}
